import * as types from '../constants';

export function loadMySubscriptionPlan() {
  return {
    type: types.LOAD_MY_SUBSCRIPTION_PLAN,
  };
}

export function loadMySubscriptionLimit() {
  return {
    type: types.LOAD_MY_SUBSCRIPTION_LIMIT,
  };
}

export function loadUserPreferences() {
  return {
    type: types.LOAD_USER_PREFERENCES,
  };
}

export function updateUserPreferences(data) {
  return {
    type: types.UPDATE_USER_PREFERENCES,
    data,
  };
}

// export function updateIPIndicatorsOrganization(data) {
//   return {
//     type: types.UPDATE_IP_INDICATORS_ORGANIZATION,
//     data,
//   };
// }

export function setCustomIPRangeIndicator(data) {
  return {
    type: types.SET_CUSTOM_IP_RANGE_INDICATOR,
    data,
  };
}

export function setCustomGeoIP(data) {
  return {
    type: types.SET_CUSTOM_GEO_IP,
    data,
  };
}

export function loadCustomGeoIPOrganisation() {
  return {
    type: types.LOAD_CUSTOM_GEO_IP_ORGANISATION,
  };
}

export function loadCustomDomainIndicators() {
  return {
    type: types.LOAD_CUSTOM_DOMAIN_INDICATORS,
  };
}

export function setCustomDomainIndicators(data) {
  return {
    type: types.SET_CUSTOM_DOMAIN_INDICATORS,
    data,
  };
}

export function deleteCustomDomainIndicators(data) {
  return {
    type: types.DELETE_CUSTOM_DOMAIN_INDICATORS,
    data,
  };
}

export function loadCustomIPRangeIndicators() {
  return {
    type: types.LOAD_CUSTOM_IP_RANGE_INDICATORS,
  };
}

export function setCustomIPRangeIndicators(data) {
  return {
    type: types.SET_CUSTOM_IP_RANGE_INDICATORS,
    data,
  };
}
export function updateCustomIPRangeIndicators(data) {
  return {
    type: types.UPDATE_CUSTOM_IP_RANGE_INDICATORS,
    data,
  };
}
export function deleteCustomIPRangeIndicators(data) {
  return {
    type: types.DELETE_CUSTOM_IP_RANGE_INDICATORS,
    data,
  };
}

export function loadCustomGeoIP(uuid) {
  return {
    type: types.LOAD_CUSTOM_GEO_IP,
    uuid,
  };
}

export function inviteUser(uuid) {
  return {
    type: types.INVITE_USER,
    uuid,
  };
}

export function loadUser() {
  return {
    type: types.LOAD_USER,
  };
}

export function loadOrganization() {
  return {
    type: types.LOAD_ORGANIZATION,
  };
}

export function updateUserProfile(data) {
  return {
    type: types.UPDATE_USER_PROFILE,
    data,
  };
}

export function changePassword(data) {
  return {
    type: types.CHANGE_PASSWORD,
    data,
  };
}

export function updateOrganization(data) {
  return {
    type: types.UPDATE_USER_ORGANIZATION,
    data,
  };
}

export function uploadPhoto(data) {
  return {
    type: types.UPLOAD_PHOTO,
    data,
  };
}

export function loadUsers() {
  return {
    type: types.LOAD_USERS,
  };
}

export function createUser(data) {
  return {
    type: types.CREATE_USER,
    data,
  };
}

export function updateUser(user) {
  return {
    type: types.UPDATE_USER,
    user,
  };
}

export function deleteUser(user) {
  return {
    type: types.DELETE_USER,
    user,
  };
}

export function loadUsersInfo() {
  return {
    type: types.LOAD_USERS_INFO,
  };
}

export function setWebsocketConnectionStatus(websocketConnectionStatus) {
  return {
    type: types.SET_WEBSOCKET_CONNECTION_STATUS,
    websocketConnectionStatus: websocketConnectionStatus,
  };
}

export function setWebsocketConnection(websocketConnection) {
  return {
    type: types.SET_WEBSOCKET_CONNECTION,
    websocketConnection: websocketConnection,
  };
}
